module.exports = __webpack_public_path__ + "img/role-video.beac7a05.png";